import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { globals} from "../Components/Globals/Globals";
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl,GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously} from "datasync-core";
import { produce } from 'immer';
const initialState = {
  statsItems: [],
  statCount: 0,
  loadStats_result:{status: 'idle', error: null},
  deleteStat_result:{status: 'idle', error: null},
  validateStats_result:{status: 'idle', error: null, stat_email:null, stat_action:null},
}

// Create an async thunk for loading stats
export const loadStats = createAsyncThunk(
  'stats/loadStats',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.platform_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` true `, // Do not filter stats
        table_guid: globals.datasync.pf_stats_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadStats::stats response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Create an async thunk for deleting stats
export const deleteStat = createAsyncThunk(
  'stats/deleteStat',
  async (deletedStatObject) => {
    try {
      console.clear()
      console.log("deletedStatObject->", deletedStatObject)
      //Delete stat from Remote Datasync Database
      const response = await SyncDeleteSynchronously({
        datasync_url:globals.datasync_service.url,
        data_guid: deletedStatObject.data_guid});
      
      if (globals.parameters.debugging)
        console.log("deleteStat->response = ",response)

      if (response.err || response.deleted_data_count !=1)
        throw(response.err)

      return response;
    } catch (error) {
      return deletedStatObject.rejectWithValue(error.message);
    }
  }
);

const statSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    addStat(state, action) {
      // New stat added 
      try {
        if (globals.parameters.debugging){
          console.log("addStat: ", state.statsItems)
          console.log("addStat: ", state.statCount)
          console.log("addStat::action ->", action)  
        }
  
        state.statCount++;
        state.statsItems.push(action.payload);
      } catch (error) {
        console.error("Stat added but state list insertion fails !")
        alert("Echec de l'insertion du nouvel utilisateur en mémoire interne")
      }
    },

    updateStat(state, action) {
      return produce(state, draft => {
        //Find former stat object to update
        const updatedStatObject = draft.statsItems.find((stat) => stat.data_guid === action.payload.data_guid)
        console.log("updateStat: updatedStatObject->", updatedStatObject)
        if (updatedStatObject) {
          //update stat in the array
          updatedStatObject.data_blob.data_tier = action.payload.data_blob.data_tier;
        } else {
          console.error("updateStat: Stat not found in the array");
        }
      })
    },

    revertAllStats(state){
      console.log("statSlice revertAllStats");
      state.statsItems = [];
      state.statCount = 0;
      state.loadStats_result = {status: 'idle', error: null};
      state.deleteStat_result = {status: 'idle', error: null};
      state.validateStats_result = {status: 'idle', error: null, stat_email:null, stat_action:null};
    },

    revertStatusStat(state){
      if (globals.parameters.debugging)
        console.log("statSlice revertStatus")

      state.deleteStat_result = {status: 'idle', error: null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadStats */
      .addCase(loadStats.pending, (state, action) => {
        state.loadStats_result = {status : "loading",error : null};
      })
      .addCase(loadStats.fulfilled, (state, action) => {
        if (action.payload.length > 0) {
          state.loadStats_result = {status : "succeeded",error : null};
          state.statsItems = action.payload;
          state.statCount= action.payload.length;
        }
        else {
          state.loadStats_result = {status : "succeeded",error : "No stats found !!!"};
          state.statsItems = [];
          state.statCount= 0;
        }
      })
      .addCase(loadStats.rejected, (state, action) => {
        state.loadStats_result = {status : "failed",error : action.payload};
      })

      /* deleteStat */
      .addCase(deleteStat.pending, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteStat.pending")
        console.log("deleteStat.pending -> action", action)
        state.deleteStat_result = {status : "deleting",error : null};
      })
      .addCase(deleteStat.fulfilled, (state,action) => {
        //Stat sucessfully deleted from syncDeleteAsynchronous process
        if (globals.parameters.redux_debugging) alert("deleteStat.fulfilled")
          console.log("deleteStat.fulfilled -> action", action, " state->", state)

        return produce(state, draft => {
          //Delete stat from local state
          draft.statsItems = draft.statsItems.filter((stat, j) => stat.data_guid !== action.payload.data_guid)
          draft.statCount--;

          draft.deleteStat_result = {status : "deleted",error : null};
        })
      })
      .addCase(deleteStat.rejected, (state,action) => {
        if (globals.parameters.redux_debugging) alert("deleteStat.rejected")
          console.log("deleteStat.rejected -> action", action)
        state.deleteStat_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addStat, updateStat, revertAllStats, revertStatusStat } = statSlice.actions;
export default statSlice.reducer;